export default class Routes {
    /* Until we get a better solution, please keep these somewhat organized */

    /* General */
    public static BASE_ROUTE = '/';
    public static LOGIN = '/login';
    public static LOGOUT = '/logout';
    public static FORGOT_PASSWORD = '/forgot-password';
    public static RESET_PASSWORD = '/reset-password/:userId/:resetPasswordId';
    public static ACCOUNT = '/account';
    public static STATEMENTS = '/statements';
    public static EDIT_STATEMENT = '/statements/:statementId';
    public static PARENTS_HOME = '/parents';
    public static PARENTS = '/parents/:gradeId';
    public static PARENTS_OBJECTIVES = '/parents/:gradeId/objectives';
    public static PARENTS_PLANET = '/parents/:gradeId/:planet';
    public static TRAINING_AND_EDUCATION_GUIDE = '/training-and-education-guide';
    public static HOLLAND_AREAS_GUIDE = '/holland-areas-guide';
    public static OCCUPATIONDB = '/occupationdb';
    public static OCCUPATION = '/occupation/:id';
    public static REGISTER = '/register';
    public static REGISTERAFL = '/register-afl';

    public static WHO_AM_I = '/whoami';
    public static DIAGNOSTICS = '/diagnostics';

    /* Error Handling */
    public static ERROR_PAGE = '/the-handler';
    public static PROD_ERROR_PAGE = '/errors';
    public static PAGE_NOT_FOUND = '/404';

    /* Examples */
    public static EXAMPLE_HOME = '/example';
    public static EXAMPLE_REDUX = '/example/redux';
    public static EXAMPLE_MULTILINGUAL = '/example/multilingual';
    public static EXAMPLES_VIDEO = '/example/video';
    public static EXAMPLES_FORM = '/example/form';

    /* Admin */
    public static ADMIN_OCCUPATIONDB = '/admin/occupationdb';
    public static ADMIN_OCCUPATION = '/admin/occupation/:id';
    public static ADMIN_USERS = '/admin/users/:isAdminTable';
    public static ADMIN_MATCHMAKER = '/admin/matchmaker';
    public static ADMIN_SYNC_MATCHMAKER_DATA = '/admin/sync-matchmaker-data';
    public static ADMIN_ADD_EDIT_USER = '/admin/add-edit-user/:classroomId/:userId/:isAdmin';
    public static ADMIN_AUDIO = '/admin/audio';
    public static ADMIN_TEST = '/admin/test/:id';
    public static ADMIN_CLIENTS = '/admin/clients';
    public static ADMIN_ADD_EDIT_CLIENT = '/admin/add-edit-client/:id';
    public static ADMIN_ADD_EDIT_CLIENT_SUBSCRIPTION = '/admin/add-edit-client-subscription/:clientId/:clientSubscriptionId';
    public static ADMIN_STATEMENTS = '/admin/statements';
    public static ADMIN_STUDENT_STATEMENTS = '/admin/student-statements/:classroomId/:userId';
    public static ADMIN_ADD_EDIT_STATEMENT = '/admin/add-edit-statement/:id';
    public static ADMIN_DISTRICTS = '/admin/districts/';
    public static ADMIN_ADD_EDIT_DISTRICT = '/admin/add-edit-district/:id';
    public static ADMIN_SYNC_MANAGEMENT = '/admin/sync-management';
    public static ADMIN_SCHOOLS = '/admin/schools/';
    public static ADMIN_ADD_EDIT_SCHOOL = '/admin/add-edit-school/:id';
    public static ADMIN_ACTIVITIES = '/admin/activities/';
    public static ADMIN_ADD_EDIT_ACTIVITY = '/admin/add-edit-activity/:id';
    public static ADMIN_ADD_EDIT_ACTIVITY_QUESTION = '/admin/add-edit-activity-question/:activityId/:activityQuestionId';
    public static ADMIN_ADD_EDIT_ACTIVITY_QUESTION_CATEGORY = '/admin/add-edit-activity-question-category/:activityId/:activityQuestionCategoryId';
    public static ADMIN_ADD_EDIT_ACTIVITY_QUESTION_RESPONSE = '/admin/add-edit-activity-question-response/:activityId/:activityQuestionId/:activityQuestionResponseId';
    public static ADMIN_MULTILINGUAL = '/admin/multilingual';
    public static ADMIN_CLASSROOMS = '/admin/classrooms/';
    public static ADMIN_ADD_EDIT_CLASSROOM = '/admin/add-edit-classroom/:id';
    public static ADMIN_ACADEMICS = '/admin/academics/';
    public static ADMIN_ADD_EDIT_ACADEMIC_STANDARD = '/admin/add-edit-academic-standard/:id';
    public static ADMIN_ADD_EDIT_ACADEMIC_STANDARD_FRAMEWORK = '/admin/add-edit-academic-standard-framework/:id';
    public static ADMIN_RESET_PASSWORD = '/admin-reset-password/:classroomId/:userId/:isAdmin';
    public static ADMIN_REPORTS = '/admin/reports';
    public static ADMIN_REPORT_STUDENT_ACTIVITY_DETAIL = '/admin/reports/student-activity-detail';
    public static ADMIN_REPORT_STUDENT_PLANET_COMPLETION = '/admin/reports/student-planet-completion';
    public static ADMIN_REPORT_STUDENT_GAME_COMPLETION = '/admin/reports/student-game-completion';
    public static ADMIN_REPORT_STUDENT_STATEMENT = '/admin/reports/student-statement';
    public static ADMIN_SYNC_RESULTS = '/admin/sync-results/:id/:districtId';
    public static ADMIN_ADD_EDIT_ACTIVITY_SUMMARY = "/admin/add-edit-activity-summary/:activityId/:activitySummaryId";
    public static ADMIN_STUDENT_VIEWS = '/admin/studentViews';
    public static ADMIN_RESOURCES = '/admin/resources';
    public static ADMIN_LESSON_PLANS = '/admin/lesson-plans';
    public static ADMIN_EMULATE_USER = '/admin/emulate';
    public static ADMIN_REPORT_CLASSROOM = '/admin/reports/classroom/:classroomId';
    public static ADMIN_REPORT_PRINCIPAL = '/admin/reports/principal/';
    public static ADMIN_REPORT_SUPERINTENDENT = '/admin/reports/superintendent/';
    public static ADMIN_HOLLAND_AREAS_GUIDE = '/admin/holland-areas-guide';

    /* Universal User Search */
    public static ADMIN_UNIVERSAL_USER_SEARCH = '/admin/universal-user-search';
    public static ADMIN_UNIVERSAL_USER_SEARCH_STUDENT_STATEMENTS = '/admin/universal-user-search/student-statements/:userId';
    public static ADMIN_UNIVERSAL_USER_SEARCH_ADD_EDIT_USER = '/admin/universal-user-search/add-edit-user/:userId';
    public static ADMIN_UNIVERSAL_USER_SEARCH_RESET_PASSWORD = '/admin/universal-user-search/admin-reset-password/:userId';

    /* Student */
    public static STUDENT_HOME = '/student/'; // Spacestation
    public static STUDENT_PLANET = '/student/planet'; // Planet pages
    public static STUDENT_RETURN = '/student/return';

    /* Mission */
    public static MISSION_SPACE_STATION = '/mission/:gradeId/space-station';
    public static MISSION_PLANET = '/mission/:gradeId/planet';
    public static MISSION_GAME = '/mission/:gradeId/game';
    public static MISSION_ACTIVITY = '/mission/:gradeId/activity';
    public static MISSION_CONCLUSION = '/mission/:gradeId/conclusion';

    /* Game Demos */
    public static GAMEDEMO_PHASER_DEMO = '/gameDemo/phaserDemo';
    public static GAMEDEMO_PHASER_DRAGDROP_DEMO = '/gameDemo/phaserDragDrop';
    public static GAMEDEMO_PHASER_PAINT_DEMO = '/gameDemo/phaserPaint';
    public static GAMEDEMO_PHASER_PLATFORMER_DEMO = '/gameDemo/phaserPlatformer';
    public static GAMEDEMO_PHASER_ANIMATION_DEMO = '/gameDemo/phaserAnimation';
    public static GAMEDEMO_PATH_FINDING_DEMO = '/gameDemo/pathFindingDemo';
    public static GAMEDEMO_IMAGE_PASTING_DEMO = '/gameDemo/imagePastingDemo';
    public static GAMEDEMO_MULTI_SCENE_DEMO = '/gameDemo/phaserMultiSceneDemo';
    public static GAMEDEMO_CAMERA_ANIMATION_DEMO = '/gameDemo/phaserCameraAnimationDemo';
    public static GAMEDEMO_GAMEPAD_TEST = '/gameDemo/gamePadDemo';
    public static GAMEDEMO_MODAL_BUTTON_DEMO = '/gameDemo/modalButtonDemo';
    public static GAMEDEMO_NPC_FOLLOWING_DEMO = '/gameDemo/npcFollowingDemo';
    public static GAMEDEMO_LANDSCAPING = '/game/old-grade5-r';
    public static GAMEDEMO_HOW_TO_PLAY_SCENE = '/game/howToPlayScene';

    /* Games */
    public static GAME_HOME = '/game/';

    public static GAME_GRADE_5_R = '/game/grade5-r'; // landscaping
    public static DIAGNOSIS_GAME = '/game/diagnosisGame';
    public static COLLAGE_GAME = '/game/collageGame';
    public static GAME_GRADE_5_S = '/game/grade5-s'; // JobMatching
    public static COLONY_GAME = '/game/colonyGame';
    public static PUZZLE_SLIDER = '/game/puzzleSlider';

    public static PLUMBING_PLATFORMER = '/game/grade4-r';
    public static GAME_GRADE_4_I = '/game/grade4-i'; //universityGame
    public static PHASER_PAINT_GAME = '/game/grade4-a';
    public static GAME_GRADE_4_S = '/game/grade4-s'; // dinner_dash
    public static GAME_GRADE_4_E = '/game/grade4-e'; // CareerFair
    public static ORGANIZE_DESK_GAME = '/game/grade4-c';

    public static DISEASED_TREES_GAME = '/game/diseasedTreesGame';
    public static XRAY_SLIDER = '/game/xraySlider';
    public static GAME_GRADE_3_A = '/game/grade3-a'; // Terraforming
    public static FIT_FIVE_GAME = '/game/fitFiveGame';
    public static HOTEL_AURORA_GAME = '/game/hotelAuroraGame';
    public static WAREHOUSE_GAME = '/game/warehouseGame';

    public static MAIL_DELIVERY = "/game/mailDelivery";
    public static PROGRAM_ROBOT = '/game/programRobot';
    public static ROCKET_REPAIR = "/game/rocketRepair";
    public static JIGSAW_PUZZLE = '/game/jigsawPuzzle';
    public static SHIP_PAINTING = '/game/shipPainting';
    public static SPACE_PORT = '/game/spacePort';

    public static SEEK_AND_FIND = '/game/seekAndFind';
    public static CITY_BUILDER = '/game/cityBuilder';
    public static VENDING_MACHINE = '/game/vendingMachine';
    public static SPACE_PETS = '/game/spacePets';
    public static OCEAN_CLEANUP = '/game/oceanCleanup';
    public static CAKE_DECORATING = '/game/cakeDecorating';
    public static UNIFORM_DESIGN = '/game/uniformDesign';
    public static FIND_HELPERS = '/game/findHelpers';

    public static TICKET_TAKER = '/game/ticketTaker';
    public static ZOO = '/game/zoo';
    public static CONSTRUCTION_MAZE = '/game/constructionMaze';
    public static STARBALL = '/game/starball';
    public static LIBRARIAN = '/game/librarian';
    public static WAITER_MEMORY = '/game/waiterMemory';

    public static RIDE_MECHANIC = '/game/rideMechanic';
    public static FOSSIL_FINDER = '/game/fossilFinder';
    public static FACE_PAINTING = '/game/facePainting';
    public static GROCERY_BAGGER = '/game/groceryBagger';

    /**
     * Returns a path with params injected into URL parameters. Params are injected into the path in the order they are specified.
     *
     * @param path The path to inject params into.
     * @param params Values to inject into path.
     */
    public static getRoute(path: string, ...params: any[]) {
        if (typeof path !== 'string') {
            console.error('Path: "' + path + '" is not a string.');
            return;
        }

        let result = '';
        let startIndex = 0;
        let endIndex = 0;

        let i = 0;
        let length = params.length;
        for (i = 0; i < length; ++i) {
            endIndex = path.indexOf(':', startIndex);
            if (endIndex === -1) {
                if (result) {
                    break;
                }

                return path;
            }

            result += path.substring(startIndex, endIndex) + params[i];

            startIndex = path.indexOf('/', endIndex);
            if (startIndex === -1) {
                startIndex = path.length;
            }
        }

        endIndex = path.indexOf(':', startIndex);
        for (i = 0; endIndex > -1; ++i) {
            startIndex = path.indexOf('?', endIndex);

            if (startIndex === -1) {
                console.error('Length of params "' + params + '" does not match number of parameters in "' + path + '".');
                return;
            }

            endIndex = path.indexOf(':', startIndex);
        }
        if (startIndex !== path.length && i === 0) {
            result += path.substring(startIndex);
        }

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/core/Routes.ts